module.exports = __webpack_public_path__ + "img/legend.9baa4060.png";